<span class="warning" [ngClass]="{ 'green': color === 'green' }">{{ message | translate }}</span>
